// import './polyfills';
import './common.scss';
import PlayerUI from './player-ui';
import Layout from './layouts/layout';
import Components from './components';

// export Layout as a static property on player UI
PlayerUI.Layout = Layout;

// export Components as a static property on player UI
PlayerUI.Components = Components;

export default PlayerUI;
